<template>
  <span class="ag-grid-text">{{ value }}</span>
</template>

<script>
export default {
  name: 'AgGridText',
  props: {
    // 组件唯一标识
    mark: {
      type: String,
      default: ''
    },
    // 绑定值
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  mounted() {
    // 返回当前组件指向
    this.mark && this.$emit('getComponent', this)
  },
  methods: {
    setValue(value) {
      this.$emit('update:value', value)
      this.$emit('getVal', this.value)
    }
  }
}
</script>

